import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
  name: "noticiaPage",
  data() {
    let ss = new MainService();
    return {
      msg: "noticiaPage",
      ss: ss,
      ajax: {
        url: ss.indexNoticia(),
        headers: ss.getToken(),
      },
      columns: [
        {
          data: "id",
          name: "id",
          orderable: false,
          searchable: false,
          visible: false,
        },
        {
          data: "DT_RowIndex",
          name: "DT_RowIndex",
          title: "N",
          orderable: false,
          searchable: false,
        },
        { data: "Noticia", name: "Noticia", title: "Noticia" },
        { data: "Descripcion", name: "Descripcion", title: "Descripcion" },
        { data: "Fecha", name: "Fecha", title: "Fecha" },
        { data: "Activo", name: "Activo", title: "Activo" },
        // {
        //     data: 'action',
        //     orderable: false,
        //     title: 'Acciones',
        //     searchable: false
        // },
      ],
      noticias: [],
      noticia: {},
      isLoading: false,
      errorBag: {},
    };
  },
  methods: {
    newNoticia() {
      this.noticia = {};
      this.$refs["frm-noticia"].show();
    },
    showNoticia(id) {
      this.isLoading = true;
      this.ss
        .showNoticia(id)
        .then((result) => {
          let response = result.data;
          this.noticia = response.data;
          this.$refs["view-noticia"].show();
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    editNoticia() {
      this.$refs["frm-noticia"].show();
      this.$refs["view-noticia"].hide();
    },
    cancelNoticia() {
      if (this.noticia.id) {
        this.$refs["view-noticia"].show();
      }
      this.$refs["frm-noticia"].hide();
    },
    saveNoticia() {
      this.ss
        .storeNoticia(this.noticia)
        .then((result) => {
          console.log(result);
          let response = result.data;
          this.$bvToast.toast(response.msg, {
            title: this.$t("messages.success"),
            variant: "success",
            autoHideDelay: 5000,
          });
          //this.$refs['view-consulta'].show(); //para volver al modal
          console.log(response);
          this.$refs["frm-noticia"].hide();
          this.$refs["datatable-noticia"].reload();
        })
        .catch((error) => {
          this.errorBag = error.response.data.errors;
          this.$bvToast.toast(this.$t("messages.problemSave"), {
            title: "Error",
            variant: "danger",
            autoHideDelay: 5000,
          });
        });
    },
    deleteNoticia() {
      this.$swal({
        title: "Estas seguro que deseas eliminar?",
        text: "Esta accion es irreversible!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete.isConfirmed) {
          this.ss
            .destroyNoticia(this.noticia)
            .then((result) => {
              let response = result.data;
              console.log(response);
              this.$bvToast.toast(response.msg, {
                title: this.$t("messages.success"),
                variant: "success",
                autoHideDelay: 5000,
              });
              this.$refs["view-noticia"].hide();
              this.$refs["datatable-noticia"].reload();
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          //swal("Your imaginary file is safe!");
        }
      });
    },
    draw() {
      window.$(".btn-datatable-Noticia").on("click", (evt) => {
        const data = window.$(evt.target)[0].id;
        this.showNoticia(data);
      });
    },
  },
  components: {
    dataTable,
    Loader,
  },
  mounted() {
    var persona = JSON.parse(localStorage.getItem("persona"));
    if (!persona) {
      this.$router.push("/Admin/Login");
    } else {
      if (persona.Rol !== 1) {
        this.$router.push("/Admin/Login");
      }
    }
  },
};
